import { t } from '@lingui/macro'
import { Text, View } from '@react-pdf/renderer'
import { myI18n } from 'translation/I18nConnectedProvider'
import { defaultFormPdfFontFamily, inuktitutFormPdfFontFamily } from './FormPdf'
import { pdfDefaultFontSize } from './PDFCommon'

type ConditionState = 'required' | 'minFiles' | 'maxFiles' | (string & {})

type FormElementTitlePDFProps = {
  index: number
  showNumering?: boolean
  title: React.ReactNode
  language: string
  helpText?: React.ReactNode
  required?: boolean
  minFiles?: number
  formViewType?: 'editable' | 'printable' | 'pdf' | 'fillable-pdf'
  conditionsMet?: Array<
    {
      condition: string
      conditionTarget: string
      minFiles?: string
      maxFiles?: string
      parameter: string
      state: ConditionState
    } & {
      [key in ConditionState]?: string
    }
  >
}

export const FormElementTitlePDF = ({
  index,
  helpText,
  showNumering,
  language,
  title,
  required = false,
  conditionsMet,
  formViewType,
  minFiles
}: FormElementTitlePDFProps): JSX.Element => {
  const conditionMetStates = conditionsMet ?? []
  const labels: string[] = []

  const minFilesCondition = conditionsMet?.find((c) => c.state === 'minFiles')
  const minNumOfFiles = minFilesCondition?.minFiles ?? minFiles

  if (minNumOfFiles != null) {
    labels.push(myI18n._(t`You need to upload at least ${minNumOfFiles} file!`))
  }

  const hasRequired = conditionMetStates.some((c) => c.state === 'required')
  const hasNotRequired = conditionMetStates.some((c) => c.state === 'notRequired')

  const resolvedRequired: boolean = hasRequired ? true : hasNotRequired ? false : required
  if (resolvedRequired) {
    labels.push(myI18n._(t`Required`))
  }

  return (
    <>
      <Text
        style={{
          fontSize: 10,
          fontWeight: 'bold',
          marginBottom: 8,
          fontFamily: language === 'iu-cans' ? inuktitutFormPdfFontFamily : defaultFormPdfFontFamily
        }}
      >
        {showNumering === true && String(index) + '. '}
        {title}
        {labels.length > 0 && formViewType === 'fillable-pdf' ? ` (${labels.join(', ')})` : ''}
      </Text>
      {helpText != null ? (
        <View>
          <Text
            style={{
              fontSize: pdfDefaultFontSize - 2,
              fontStyle: 'italic',
              marginBottom: 8,
              fontFamily:
                language === 'iu-cans' ? inuktitutFormPdfFontFamily : defaultFormPdfFontFamily
            }}
          >
            {helpText}
          </Text>
        </View>
      ) : (
        <View />
      )}
    </>
  )
}
